export const LocalStorageKeys = {
  // Commons
  auth: {
    user: "@auth/user",
  },
  coach: {
    onboarding: {
      redirect: "@coach/onboarding/redirect",
    },
  },
  featureToggle: {
    featureToggles: "@featureToggle/featureToggles",
  },
  language: {
    languageCode: "@profile/languageCode",
  },

  // Mobile only
  explore: { history: "@explore/history" },
  profile: {
    theme: "@profile/theme",
    unit: "@profile/unit",
  },
  notification: "@profile/notification",
  messaging: {
    config: "@messagin/config",
  },

  // Web only
  space: {
    currentBox: "@space/currentBox",
    redirectionProgramId: "@space/redirection/programId",
    redirectionProgramType: "@space/redirection/programType",
  },
  appBanner: {
    visibility: "@appBanner/visibility",
  },
  templatePopup: {
    checked: "@templatePopup/checked",
  },
  training: {
    training: "@training/training",
  },
  boxPlanning: {
    planning: "@boxPlanning/planning",
  },
  boxProgram: {
    defaultSettings: "@boxProgram/defaultSettings",
  },
  boxSlotTemplate: {
    dontShowOnBoardingAnymore: "@boxSlotTemplate/dontShowOnBoardingAnymore",
  },
  programBundleInvitation: "@programBundle/invitation",
  sharedCoachInvitation: {
    programId: "@sharedCoachInvitation/invitation/programId",
    programType: "@sharedCoachInvitation/invitation/programType",
  },
  boxStaffInvitation: {
    boxId: "@boxStaffInvitation/invitation/boxId",
  },
  boxOfferInvitation: {
    invitation: "@boxOfferInvitation/invitation",
  },
  boxTransaction: {
    transactionId: "@boxTransaction/transactionId",
  },
  boxInvitation: "@boxInvitation/invitation",
  scoreFormDifficulty: "@scoreForm/difficulty",
}
